import request from '@/utils/request'

// 查询员工作业(每日)统计列表
export function listUserOperations(query) {
  return request({
    url: '/system/user-operations/list',
    method: 'get',
    params: query,
  })
}

// 查询员工作业(每日)统计分页
export function pageUserOperations(query) {
  return request({
    url: '/system/user-operations/page',
    method: 'get',
    params: query,
  })
}

// 查询员工作业(每日)统计详细
export function getUserOperations(data) {
  return request({
    url: '/system/user-operations/detail',
    method: 'get',
    params: data,
  })
}

// 新增员工作业(每日)统计
export function addUserOperations(data) {
  return request({
    url: '/system/user-operations/add',
    method: 'post',
    data: data,
  })
}

// 修改员工作业(每日)统计
export function updateUserOperations(data) {
  return request({
    url: '/system/user-operations/edit',
    method: 'post',
    data: data,
  })
}

// 删除员工作业(每日)统计
export function delUserOperations(data) {
  return request({
    url: '/system/user-operations/delete',
    method: 'post',
    data: data,
  })
}
